<template>
<!-- 听单分类详情 -->
    <div v-if="classifyItem !== undefined" style="width:100%;background:#fff;">
        <!-- 头部 -->
        <div class="top-model">
            <img class="back" @click="back" src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
            <img @click="$router.push('/search')" class="search" src="icon/learnIcon/search.svg" alt="">
            <img class="classify" @click="$refs.drawerClassify.open()" src="icon/learnIcon/classify.svg" alt="">
        </div>
        <!-- 详情标题 -->
        <div style="margin-bottom:29px;">
            <div class="title" :style="{background:bgTitle[random]}">
                <h3>{{classifyItem.name || ''}}</h3>
            </div>
            <span class="explanation">{{classifyItem.describe || ''}}</span>
        </div>
        <!-- 最新上架 -->
        <new-releases  :random="random" :classifyItem="classifyItem"></new-releases>
        <!-- 其他推荐 -->
        <recommend :classifyItem="classifyItem"></recommend>
        <!-- 分类弹出抽屉 -->
        <drawer-classify v-on:childByValue="childByValue" :classifySumList="classifySumList" ref="drawerClassify"></drawer-classify>
    </div>
    <div v-else>
        没内容
    </div>
</template>
<script>
// 最新上架模块
import newReleases from './newReleases';
// 其他分类模块
import recommend from './recommend';
// 分类弹出抽屉模块
import drawerClassify from './drawerClassify';

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// util
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/api/audio/category',
            dataPath : 'data',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};

export default {
    name: "classifyDetail",
    extends : shixunPagePart,
    watch:{
        $route(to ,from){
            if(to.params.id && from.params.id && (to.params.id !== from.params.id)){
                this.getId = to.params.id;
               this.onLoadDataList();
            }
        },
    },
    data(){
        return {
            // 路由传id
            getId:this.$route.params.id,
            //id对应内容
            classifyItem:null,
            // 标题背景颜色
            bgTitle:['#FF9295','#FFD381','#BDE6FF',],
            // 产生0-2随机数
            random:Math.floor(Math.random()*3),
            // 保存分类列表
            classifySumList:[],

            drawerId:'',

            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,


        }
    },
    components:{
        newReleases,
        recommend,
        drawerClassify
    },
    created(){

    },
    methods:{
         childByValue: function (childValue) {
            // childValue就是子组件传过来的值
            this.drawerId = childValue;
            this.$router.push({name:'classifyDetail',params: {id:this.drawerId}})
        },



        back(){
             appHelper.back(this)
        },
        onLoadDataList(){
            let classifyList = this.dataList
            this.classifySumList = classifyList
            let itemList =  classifyList.filter(item =>{
                return item.id === this.getId
            })
            this.classifyItem = itemList[0];
            appHelper.setTitle(this.classifyItem.name);

            if (deviceHelper.isBrowser && browserHelper.isWechat)
            {
                this.setWechatShare();
            }
        },

        setWechatShare : function() {

            let wechatShareOptions = {
                // title   : this.classifyItem.name,
                title   : appHelper.getTitle(),
                desc    : this.classifyItem.desc || appConfig.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };

            wechatHelper.setShare(wechatShareOptions);
        }

    },
    mounted(){
        this.onLoadDataList();
    },
}
</script>
<style lang="scss" scoped>
.top-model{
    position: relative;
    box-sizing: border-box;
    width: 90%;
    margin: 0 auto;
    height: 44px;
    padding: 11px 0;
    .back{
        width: 22px;
        height: 22px;
    }
    .search{
        position: absolute;
        right: 48px;
        width: 24px;
        height: 24px;
    }
    .classify{
        position: absolute;
        right: 0;
        width: 24px;
        height: 24px;
    }

}

.title{
    position: relative;
    margin-left: 5%;
    margin-top: 24px;
    width: 75px;
    height: 9px;
    background: #FF9295;

    h3{
        position: absolute;
        top: -20px;
        left: 0;
        width: 120px;
        font-size: 22px;

        font-weight: 600;
        color: #333333;

        margin: 0;
        padding: 0;
    }
}

.explanation{
    margin-left: 5%;

    font-size: 12px;

    font-weight: 400;
    color: #333333;

}

</style>
